import { MovementEntity } from "@modules/profile/publicProfile/entities/movementEntity"
import { PersonalRecordEntity } from "@modules/profile/publicProfile/entities/personalRecordEntity"
import { type FavoritePersonalRecordDto } from "@modules/profile/publicProfile/gateway/publicProfileDto"

export class FavoritePersonalRecordEntity {
  movement: MovementEntity
  personalRecord: PersonalRecordEntity | null
  favorite: boolean | null

  private constructor(entity: FavoritePersonalRecordEntity) {
    this.movement = entity.movement
    this.personalRecord = entity.personalRecord
    this.favorite = entity.favorite
  }

  static fromDto(dto: FavoritePersonalRecordDto): FavoritePersonalRecordEntity {
    return new FavoritePersonalRecordEntity({
      movement: MovementEntity.fromDto(dto.movement),
      personalRecord: dto.personalRecord ? PersonalRecordEntity.fromDto(dto.personalRecord) : null,
      favorite: dto.favorite ?? null,
    })
  }
}
